import m, {Vnode, VnodeDOM} from "mithril";
import ItemsSuggestionSource, {Item} from "./source/ItemsSuggestionSource";
import ISuggestionSource from "./source/ISuggestionSource";

const autocomplete = require('autocomplete.js');

type AutocompleteDataset<Suggestion> = {
    source: (query: string, onResult: (result: string[])=>any) => void,
    displayKey: string,
    templates: {
        suggestion: (suggestion: Suggestion) => string
    }
};

export default class SuggestionBox {

    public suggestionSource: ISuggestionSource;
    private autocomplete: any;
    private self: SuggestionBox;
    private focusOnCreate = false;
    private autocompleteMinLength = 3;

    constructor(
        private items: Item[],
        private onSelectItem: (item: Item) => void,
        private selectedItem: Item|null = null,
    ) {
        this.suggestionSource = new ItemsSuggestionSource(items);
        this.self = this;
    }

    public setAutocompleteMinLength(l: number) {
        if (this.autocomplete) {
            throw new Error("Autocomplete already initialized. Call this method immediately after call new SuggestionBox.");
        }
        this.autocompleteMinLength = Math.round(Math.max(l, 0));
    }

    public reset() {
        this.selectedItem = null;
        const a = this.autocomplete;
        a?.autocomplete.setVal(null);
    }

    public focus() {
        if (this.autocomplete) {
            this.autocomplete[0].focus();
        } else {
            this.focusOnCreate = true;
        }
    }

    public view(): Vnode {
        return m('.SuggestionBox', {}, [
            m('input.autocomplete', {
                value: this.renderItem(this.self.selectedItem),
            }),
            this.self.selectedItem ? m('i.icon.icon-check-simple.success') : null,
        ]);
    }


    public oncreate(vnode: VnodeDOM): void {
        const input = $(vnode.dom).find('input')[0];
        const a = autocomplete(input, {
            // global options https://github.com/algolia/autocomplete.js/#global-options
            //autoselect: true,
            tabAutocomplete: true,
            openOnFocus: true,
            autoselectOnBlur: false,
            autoFocus: true,
            minLength: this.autocompleteMinLength,
            placeholder: "",
        }, [
            { // datasets https://github.com/algolia/autocomplete.js/#datasets
                source: (q :string, r :any) => this.suggestionSource.search(q,r),
                displayKey: 'item',
                templates: {
                    suggestion: (suggestion: Item) => {
                        return this.renderItemHtml(suggestion);
                    },
                },
            },
        ]).on('autocomplete:selected', (e: InputEvent, suggestion: Item, datasetIndex: number, context: any) => {
            this.self.selectedItem = suggestion;
            a.autocomplete.setVal(this.renderItem(suggestion));
            this.onSelectItem(suggestion);
            m.redraw();
        });

        this.self.autocomplete = a;
        if (this.focusOnCreate) {
            a.autocomplete.open();
            a[0].focus();
            this.focusOnCreate = false;
        }
    }

    private renderItem(item?: Item|null): string {
        if (!item) {
            return '';
        }
        const group = item.groups?.[0] || item.group;
        return item.item + (group ? ` (${group})` : '');
    }

    private renderItemHtml(item?: Item|null): string {
        if (!item) {
            return '';
        }
        const group = item.groups?.[0] || item.group;
        return item.item + (group ? ` <span class="item-group">(${group})</span>` : '');
    }
}